import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Card,
  CardContent,
  Typography,
  FormControl,
  Select,
  MenuItem,
} from '@mui/material';
import { FREQUENCIES } from './FrequencySelector';
import { DailyPattern, WeeklyPattern, MonthlyPattern, YearlyPattern } from './patterns';

export default function PatternSection({
  frequency,
  onFrequencyChange,
  interval,
  onIntervalChange,
  byWeekday,
  onByWeekdayChange,
  byMonthDay,
  onByMonthDayChange,
  byMonth,
  onByMonthChange,
  dailyMode,
  onDailyModeChange,
}) {
  const { t } = useTranslation('common');

  const renderPatternContent = () => {
    switch (frequency) {
      case FREQUENCIES.DAILY:
        return (
          <DailyPattern
            mode={dailyMode}
            onModeChange={onDailyModeChange}
            interval={interval}
            onIntervalChange={onIntervalChange}
          />
        );
      case FREQUENCIES.WEEKLY:
        return (
          <WeeklyPattern
            interval={interval}
            onIntervalChange={onIntervalChange}
            byWeekday={byWeekday}
            onByWeekdayChange={onByWeekdayChange}
          />
        );
      case FREQUENCIES.MONTHLY:
        return (
          <MonthlyPattern
            interval={interval}
            onIntervalChange={onIntervalChange}
            byMonthDay={byMonthDay}
            onByMonthDayChange={onByMonthDayChange}
          />
        );
      case FREQUENCIES.YEARLY:
        return (
          <YearlyPattern
            interval={interval}
            onIntervalChange={onIntervalChange}
            byMonth={byMonth}
            onByMonthChange={onByMonthChange}
            byMonthDay={byMonthDay}
            onByMonthDayChange={onByMonthDayChange}
          />
        );
      default:
        return null;
    }
  };

  return (
    <Card variant="outlined">
      <CardContent>
        <Typography variant="subtitle2" gutterBottom>
          {t('common:rrule.pattern.title')}
        </Typography>

        <Box display="flex" gap={2}>
          {/* Left side - Repeat label */}
          <Typography sx={{ pt: 1 }}>{t('common:rrule.frequency.repeat')}</Typography>

          {/* Right side - All content */}
          <Box flex={1} display="flex" flexDirection="column" gap={2}>
            {/* Frequency Selector */}
            <FormControl size="small" sx={{ width: 'fit-content' }}>
              <Select
                value={frequency}
                onChange={(e) => onFrequencyChange(e.target.value)}
              >
                <MenuItem value={FREQUENCIES.DAILY}>
                  {t('common:rrule.frequency.daily')}
                </MenuItem>
                <MenuItem value={FREQUENCIES.WEEKLY}>
                  {t('common:rrule.frequency.weekly')}
                </MenuItem>
                <MenuItem value={FREQUENCIES.MONTHLY}>
                  {t('common:rrule.frequency.monthly')}
                </MenuItem>
                <MenuItem value={FREQUENCIES.YEARLY}>
                  {t('common:rrule.frequency.yearly')}
                </MenuItem>
              </Select>
            </FormControl>

            {/* Frequency-specific pattern options */}
            {renderPatternContent()}
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
}
